import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { MorphingBackground } from "@/components/MorphingBackground";

export function AuthLayout() {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-bg-2">
      <MorphingBackground />
      <div className="relative z-10 w-full max-w-sm space-y-6 px-4">
        <div className="rounded-ds border border-stage-stone/10 bg-bg-2/80 p-8 shadow-2xl backdrop-blur-xl">
          <div className="mb-8 text-center">
            <img
              src="/trace-logo.svg"
              alt="TRACE"
              className="mx-auto h-8"
              style={{ filter: "var(--logo-invert)" }}
            />
            <p className="mt-3 text-xs text-ink-3">
              Technical Rider Automated Content Extraction
            </p>
          </div>
          <Outlet />
        </div>
      </div>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
